import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, filter } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { 
  ORDER_TYPE_FIND,
  ORDER_TYPE_FIND_SUCCESS,
  ORDER_TYPE_FAILED,
  ORDER_TYPE_UPDATE_LOADING
 } from '@store/actions'

import { OrderTypeService } from '../../core/services/order-type/order-type.service';
import { selectLocalChannelId } from '../selectors';
import { OrderType } from '@core/models';

@Injectable()
export class OrderTypeEffects {
  localChannelId$: Observable<string | null>;

  constructor(
    private actions$: Actions,
    private orderTypeService: OrderTypeService,
    private store: Store<Store>,
  ) {
    this.localChannelId$ = this.store.select(selectLocalChannelId)
  }

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ORDER_TYPE_FIND),
      withLatestFrom(
        this.store.select(selectLocalChannelId)
      ),
      filter(([_, localChannelId]) => !!localChannelId),
      map(([_, localChannelId]) => {
        return { localChannelId: localChannelId as string }
      }),

      mergeMap(({ localChannelId }) => {
        this.store.dispatch(ORDER_TYPE_UPDATE_LOADING({ loading: true }));
        return this.orderTypeService.find(localChannelId).pipe(
          mergeMap(({ data }) => {
            const orderTypeList = data as OrderType[];
            return [
              ORDER_TYPE_UPDATE_LOADING({ loading: false }),
              ORDER_TYPE_FIND_SUCCESS({ orderTypeList }),
            ];
          }),
          catchError((error) => of(ORDER_TYPE_FAILED({
            error: error.error?.message || 'Error loading order types',
          })))
        );
      })
    )
  );
}
